export default __webpack_public_path__ + "static/media/avatar-mp-3-1.b566ea95.png";